module.exports = __webpack_public_path__ + "img/3.ec64dfe5.png";